/** Plate carriers and vests. The largest target on a body, so the heaviest plate. */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const TORSO_SLOT = {
  id: 'torso',
  label: 'Torso',
  description: 'Plate carriers and vests. The largest target on a body, so the heaviest plate.',
} as const satisfies EquipmentSlot;
